var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 6.8791665 6.8791666",
    id: "svg193",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs190"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path362",
    style: {
      fill: "#cfcfcf",
      strokeWidth: 0.264583
    },
    d: "M 0.52916666 0.52916666 L 0.52916666 6.3499999 L 6.3499999 6.3499999 L 6.3499999 1.5875 L 5.2916666 0.52916666 L 4.4979166 0.52916666 L 4.4979166 2.38125 L 1.5875 2.38125 L 1.5875 0.52916666 L 0.52916666 0.52916666 z M 1.5875 2.9104166 L 5.2916666 2.9104166 L 5.2916666 5.8208332 L 1.5875 5.8208332 L 1.5875 2.9104166 z "
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#cccccc",
      strokeWidth: 0.141426
    },
    id: "rect487",
    width: 1.0583334,
    height: 1.3229169,
    x: 2.9104166,
    y: 0.52916646
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save_icon.7335b6f2ae3e98c15c65954c598eceaa.svg";
export { ForwardRef as ReactComponent };